import type { Lesson } from '../../interfaces'
import type { LessonStatusReasons } from '../../lesson-status'
import type { LessonEditStore } from './interfaces'

import { ReasonCategory } from '@brighterly/lib-core-types/booking/enums'
import { DateFormat } from '@brighterly/lib-core-types/date/enums'

import dayjs from 'dayjs'

import { getFirstReason, isLessonReasonStatus } from '../../lesson-status'
import { createLessonEditState } from './state'

export const actions = {
  setLoading (this: LessonEditStore, payload: LessonEditStore['loading']): void {
    this.loading = payload
  },
  setLesson (this: LessonEditStore, payload: LessonEditStore['lesson']): void {
    this.lesson = payload
  },
  setSlots (this: LessonEditStore, payload: LessonEditStore['slots']): void {
    this.slots = payload
  },
  /** The form starts from the lesson as it is: its reason when it already has one, else an admin reason. */
  initForm (this: LessonEditStore, lesson: Lesson, reasons: LessonStatusReasons): void {
    const start = dayjs(lesson.start, DateFormat.Default)
    const hasReason = isLessonReasonStatus(lesson.status)
    const category = hasReason && lesson.reason_category ? lesson.reason_category : ReasonCategory.Admin

    this.date = start.format(DateFormat.DefaultDate)
    this.startTime = start.format(DateFormat.DefaultTime)
    this.duration = lesson.duration
    this.status = lesson.status
    this.reasonCategory = category
    this.reason = hasReason && lesson.reason ? lesson.reason : getFirstReason(reasons, category)
    this.tutorId = lesson.tutor_id
    this.filters = null
    this.tutorModalOpen = false
    this.actionModal = null
    this.deleteConfirmOpen = false
    this.reassignReason = null
    this.reassignComment = ''
    this.saving = false
  },
  setDate (this: LessonEditStore, payload: LessonEditStore['date']): void {
    this.date = payload
  },
  setStartTime (this: LessonEditStore, payload: LessonEditStore['startTime']): void {
    this.startTime = payload
  },
  setDuration (this: LessonEditStore, payload: LessonEditStore['duration']): void {
    this.duration = payload
  },
  setStatus (this: LessonEditStore, payload: LessonEditStore['status']): void {
    this.status = payload
  },
  setReasonCategory (this: LessonEditStore, payload: LessonEditStore['reasonCategory']): void {
    this.reasonCategory = payload
  },
  setReason (this: LessonEditStore, payload: LessonEditStore['reason']): void {
    this.reason = payload
  },
  setTutorId (this: LessonEditStore, payload: LessonEditStore['tutorId']): void {
    this.tutorId = payload
  },
  setFilters (this: LessonEditStore, payload: LessonEditStore['filters']): void {
    this.filters = payload
  },
  setTutorModalOpen (this: LessonEditStore, payload: LessonEditStore['tutorModalOpen']): void {
    this.tutorModalOpen = payload
  },
  setActionModal (this: LessonEditStore, payload: LessonEditStore['actionModal']): void {
    this.actionModal = payload
  },
  setDeleteConfirmOpen (this: LessonEditStore, payload: LessonEditStore['deleteConfirmOpen']): void {
    this.deleteConfirmOpen = payload
  },
  setReassignReason (this: LessonEditStore, payload: LessonEditStore['reassignReason']): void {
    this.reassignReason = payload
  },
  setReassignComment (this: LessonEditStore, payload: LessonEditStore['reassignComment']): void {
    this.reassignComment = payload
  },
  setSaving (this: LessonEditStore, payload: LessonEditStore['saving']): void {
    this.saving = payload
  },
  reset (this: LessonEditStore): void {
    Object.assign(this, createLessonEditState())
  },
}
